import { Component, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { FirstLoginDto } from 'src/modules/utils/shared/first-login-dto.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { FrontendFieldDefinition } from '../../models/frontend-field-definition.model';
import { FrontendFieldType } from '../../models/frontend-field-type.enum';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { BackendResponse } from '../../shared/backend-response.model';

@Component({
    selector: 'app-first-login',
    templateUrl: './first-login.component.html',
    styleUrls: ['./first-login.component.scss']
})
export class FirstLoginComponent extends ComponentView {

    static currentPassword = "";

    app = inject(MainAppService);
    message = inject(MessageService);

    form: FrontendFormDefinition;
    authQuestions: string[];

    loaded = false;
    userName = "";
    running = false;
    done = false;

    pwText = "";

    async initParams(): Promise<boolean> {
        this.userName = this.route.snapshot.queryParams.userName;
        this.pwText = this.app.mainConfig.authRules.passwordRules.getRulesText();

        this.form = new FrontendFormDefinition([
            new FrontendFieldDefinition("currentPassword", "Aktuelles Passwort", FrontendFieldType.password, { mandatory: true, passwordFeedback: false, value: FirstLoginComponent.currentPassword ?? ""}),
            new FrontendFieldDefinition("password", "Neues Passwort", FrontendFieldType.password, { mandatory: true, passwordFeedback: false}),
            new FrontendFieldDefinition("passwordRepeat", "Neues Passwort wiederholen", FrontendFieldType.password, { mandatory: true, passwordFeedback: false}),
            ...Utils.arrayMapWithIndex(this.app.mainConfig.authRules.useRecoveryQuestions ? this.authQuestions : [], (aq, index) => new FrontendFieldDefinition("authQuestion" + index, aq, FrontendFieldType.text))
        ]);

        FirstLoginComponent.currentPassword = "";

        this.loaded = true;
        return true;
    }

    async send(): Promise<void> {
        let errors = this.form.validate();
        if (errors != null) {
            this.message.add({ severity: "error", summary: "Ungültige Angaben", life: 10000, detail: Utils.toString(Utils.objectGetValues(errors)[0])});
            return;
        }

        let pw1 = this.form.getValue("password") as string;
        let pw2 = this.form.getValue("passwordRepeat") as string;

        if (pw1 != pw2) {
            this.message.add({ severity: "error", summary: "Ungültige Angaben", life: 10000, detail: "Die beiden neuen Passwörter stimmen nicht überein"});
            return;
        }

        if (!this.app.mainConfig.authRules.passwordRules.isSafe(pw1)) {
            this.message.add({ severity: "error", summary: "Ungültige Angaben", life: 10000, detail: "Das neue Passwort stimmt nicht mit den Vorgaben überein. " + this.pwText});
            return;
        }

        let authQuestions = [];
        let authAnswers = [];
        if (this.app.mainConfig.authRules.useRecoveryQuestions) {
            for (let i = 0; i < this.authQuestions.length; i++) {
                if (!Utils.isNoe(this.form.getField("authQuestion" + i).getValue())) {
                    authQuestions.push(this.authQuestions[i]);
                    authAnswers.push(this.form.getField("authQuestion" + i).getValue());
                }
            }
            if (authQuestions.length < this.app.mainConfig.authRules.minRecoveryQuestions) {
                this.message.add({ severity: "error", summary: "Ungültige Angaben", life: 10000, detail: "Es müssen mindestens " + this.app.mainConfig.authRules.minRecoveryQuestions + " Fragen beantwortet werden."});
                return;
            }
        }

        this.running = true;
        try {
            await RestEndpoint.main().post().body(Utils.fromPlain(FirstLoginDto, {
                userName: this.userName,
                currentPassword: this.form.getValue("currentPassword"),
                password: pw1,
                recoveryQuestions: authQuestions,
                recoveryAnswers: authAnswers
            })).run("api/app/auth/firstlogin").get(BackendResponse);
            this.message.add({ severity: "success", summary: "Die Aktivierung war erfolgreich.", life: 10000});
            Utils.setTimerOnce(2000, async () => {
                await this.app.navigateTo(["/base", "login"]);
            });
        }
        catch (ex) {
            // let error = Utils.fromPlainUnsafe(BackendResponse, Utils.fromJson(ex.error));
            this.message.add({ severity: "error", summary: "Die Aktivierung war nicht erfolgreich. Bitte prüfen Sie, ob das eingegebene aktuelle Passwort richtig ist", life: 10000});
        }
        this.running = false;
    }

    cancel(): void {

    }

}
